// Simple Snowflake-like ID generator for frontend
class Snowflake {
  private epoch = 1609459200000; // 2021-01-01 00:00:00 UTC
  private machineId = 1;
  private sequence = 0;
  private lastTimestamp = 0;

  generate(): number {
    let timestamp = Date.now();

    if (timestamp < this.lastTimestamp) {
      throw new Error('Clock moved backwards');
    }

    if (this.lastTimestamp === timestamp) {
      this.sequence = (this.sequence + 1) & 0xfff; // 12 bits
      if (this.sequence === 0) {
        timestamp = this.waitNextMillis(this.lastTimestamp);
      }
    } else {
      this.sequence = 0;
    }

    this.lastTimestamp = timestamp;

    const id = ((timestamp - this.epoch) << 22) | (this.machineId << 12) | this.sequence;
    return id;
  }

  private waitNextMillis(lastTimestamp: number): number {
    let timestamp = Date.now();
    while (timestamp <= lastTimestamp) {
      timestamp = Date.now();
    }
    return timestamp;
  }
}

const snowflake = new Snowflake();

export function genID(): number {
  return snowflake.generate();
}
